import React, { useEffect } from "react";
import "../../assets/styles/EditStore/EditStoreFooter.css";
import InputComponent from "../../components/TextInputComponent/TextInputComponent";
import axios from "../../js/Axios/Axios";
import { ShowAlert } from "../../action/index";
import { useSelector, useDispatch } from "react-redux";
import useForceUpdate from "use-force-update";
import Modal from "@mui/material/Modal";
import cross from "../../assets/icons/cross.svg";
import telegramWhite from "../../assets/icons/telegramWhite.svg";
import linkedinWhite from "../../assets/icons/linkedinWhite.svg";
import instagramWhite from "../../assets/icons/instagramWhite.svg";
import aparatwhite from "../../assets/icons/aparatwhite.svg";
import whatsappwhite from "../../assets/icons/whatsappwhite.svg";
import whatsappimg from "../../assets/icons/whatsapp.svg";
import linkedinimg from "../../assets/icons/linkedin.svg";
import telegramimg from "../../assets/icons/telegram.png";
import instagramimg from "../../assets/icons/instagram.png";
import aparatimg from "../../assets/icons/aparat.png";
import whiteEdit from "../../assets/icons/whiteEdit.svg";
import { useState } from "react";
import {globalState} from "../../helper/globalState";
export default function EditStoreFooter({ btn }) {
  const forceUpdate = useForceUpdate();
  const dispatch = useDispatch();
  const [modal, SetModal] = useState(false);
  const [modaldes, SetModaldes] = useState(false);
  const [telegram, setTelegram] = useState({
    key: "telegram",
    value: null,
    contactToUs_id: null,
  });
  const [whatsapp, setWatsapp] = useState({
    key: "whatsapp",
    value: null,
    contactToUs_id: null,
  });
  const [instagram, setInstagram] = useState({
    key: "instagram",
    value: null,
    contactToUs_id: null,
  });
  const [aparat, setAparat] = useState({
    key: "aparat",
    value: null,
    contactToUs_id: null,
  });
  const [linkdin, setLinkdin] = useState({
    key: "linkdin",
    value: null,
    contactToUs_id: null,
  });

  const [storeID, setStoreID] = useState(null);

  const [description, setdescription] = useState({
    key: "description",
    value: null,
    contactToUs_id: null,
  });

  const [email, setemail] = useState({
    key: "email",
    value: null,
    contactToUs_id: null,
  });
  console.log("email", email)
  const [phonenumber, setphonenumber] = useState({
    key: "phone-number",
    value: null,
    contactToUs_id: null,
  });
  const [province, setprovince] = useState({
    key: "province",
    value: null,
    contactToUs_id: null,
  });
  const [city, setcity] = useState({
    key: "city",
    value: null,
    contactToUs_id: null,
  });

  const [address, setaddress] = useState({
    key: "Address",
    value: null,
    contactToUs_id: null,
  });
  const [store_name, setstore_name] = useState({
    key: "store_name",
    value: null,
    contactToUs_id: null,
  });
  const [headerInfo, setHeaderInfo] = useState({
    companyName: null,
    companyDesc: null,
    companyState: null,
    companyNumber: null,
    companyRate: null,
    companyLogo: null,
    companyBackground: null,
  });

  const [editHeader, setEditHeader] = useState({
    store_name: null,
    storeShortDes: null,
    province_id: null,
    city_id: null,
    phone_store: null,
    storeIcon_id: null,
  });
  const [bannerInfo, setBannerInfo] = useState({
    media_id: null,
    storeBanner_id: null,
    banner_type: 1,
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [storeBannerResponse, contactToUsResponse, showInfoResponse] = await Promise.all([
          axios.get("/StoreBanner"),
          axios.get("/StoreContactToUs"),
          axios.get("/Store/showInfo")
        ]);
        console.log(11111, storeBannerResponse)
        console.log(2, contactToUsResponse)
        console.log(3, showInfoResponse)
        if (storeBannerResponse.data.status) {
          const bannerInfo = storeBannerResponse.data.data.find(item => item.banner_type === 1);
          if (bannerInfo) {
            setBannerInfo(prev => ({
              ...prev,
              storeBanner_id: bannerInfo.id,
              media_id: bannerInfo.media_id
            }));
            setHeaderInfo(prev => ({
              ...prev,
              companyBackground: bannerInfo.media_link
            }));
            forceUpdate();
          }
        }

        if (contactToUsResponse.data.status === 1) {
          contactToUsResponse.data.data.forEach(item => {
            switch (item.key) {
              case "store_name":
                setstore_name(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "description":
                setdescription(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "email":
                setemail(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "province":
                setprovince(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "Address":
                setaddress(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "city":
                setcity(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "telegram":
                setTelegram(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "whatsapp":
                setWatsapp(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;

              case "instagram":
                setInstagram(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "phone-number":
                setphonenumber(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              case "description":
                setdescription(prev => ({
                  ...prev,
                  value: item.value,
                  contactToUs_id: item.id
                }));
                break;
              // ... Repeat for other cases ...
            }
            forceUpdate();
          });
        }
        
        if (showInfoResponse.data.status) {
          setEditHeader(prev => ({
            ...prev,
            phone_store: showInfoResponse.data.data.phone_store,
            storeIcon_id: showInfoResponse.data.data.storeIcon_id,
            storeShortDes: showInfoResponse.data.data.store_short_des,
            province_id: showInfoResponse.data.data.province_id,
            city_id: showInfoResponse.data.data.city_id,
            store_name: showInfoResponse.data.data.store_name
          }));
          setStoreID(showInfoResponse.data.data.id);

          const bannerInfo = showInfoResponse?.data?.data?.find?.(item => item.banner_type === 2);
          if (bannerInfo) {
            setBannerInfo(prev => ({
              ...prev,
              storeBanner_id: bannerInfo.id,
              media_id: bannerInfo.media_id
            }));
            setHeaderInfo(prev => ({
              ...prev,
              companyBackground: bannerInfo.media_link
            }));
            forceUpdate();
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);
  const openModal = () => {
    SetModal(true);
  };
  const openModals = () => {
    SetModaldes(true);
  };
  const closeModals = () => {
    SetModaldes(false);
  };
  const closeModal = () => {
    SetModal(false);
  };
  const shareSocial = () => {
    let array = [];
    if (telegram.value != null) {
      array.push(telegram);
    }
    if (whatsapp.value != null) {
      array.push(whatsapp);
    }
    if (instagram.value != null) {
      array.push(instagram);
    }
    if (store_name.value != null) {
      array.push(store_name);
    }
    if (aparat.value != null) {
      array.push(aparat);
    }
    if (linkdin.value != null) {
      array.push(linkdin);
    }
    if (description.value != null) {
      array.push(description);
    }

    if (email.value != null) {
      array.push(email);
    }
    if (phonenumber.value != null) {
      array.push(phonenumber);
    }
    if (city.value != null) {
      array.push(city);
    }
    if (address.value != null) {
      array.push(address);
    }
    if (province.value != null) {
      array.push(province);
    }
    axios
      .post("/StoreContactToUs", array)
      .then((res) => {
        console.log("111", res)
        if (res.data.status) {
          dispatch(ShowAlert(true, res.data.message));
          SetModal(false);
          axios
            .get("/StoreContactToUs")
          console.log("2222", res)
            .then((res) => {

              if (res.data.status) {
                res.data.data.map((item, index) => {
                  if (item.key === "telegram") {
                    setTelegram((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                  if (item.key === "whatsapp") {
                    setWatsapp((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                  if (item.key === "email") {
                    setemail((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                  if (item.key === "store_name") {
                    setstore_name((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                  if (item.key === "instagram") {
                    setInstagram((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                  if (item.key === "aparat") {
                    setAparat((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                  if (item.key === "linkdin") {
                    setLinkdin((prev) => {
                      prev.value = item.value;
                      prev.contactToUs_id = item.id;
                      forceUpdate();
                      return prev;
                    });
                  }
                });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const whatsAppClick = () => {
    if (whatsapp.value !== null) {
      window.open(`httpss://${whatsapp.value}`);
    }
  };
  const linkdinClick = () => {
    if (linkdin.value !== null) {
      window.open(`httpss://${linkdin.value}`);
    }
  };
  const telegramClick = () => {
    if (telegram.value !== null) {
      window.open(`httpss://${telegram.value}`);
    }
  };
  const instagramClick = () => {
    if (instagram.value !== null) {
      window.open(`httpss://${instagram.value}`);
    }
  };
  const aparatClick = () => {
    if (aparat.value !== null) {
      window.open(`httpss://${aparat.value}`);
    }
  };

  const editHeaderClik = () => {
    axios
      .post("/StoreBanner", bannerInfo)
      .then((res) => {
        if (res.data.status) {

          axios
            .get("/StoreBanner")
            .then((res) => {
              if (res.data.status) {

                res.data.data.map((item, index) => {
                  if (item.banner_type === 2) {
                    setBannerInfo((prev) => {
                      prev.storeBanner_id = item.id;
                      prev.media_id = item.media_id;
                      return prev;
                    });
                    setBannerInfo((prev) => {
                      prev.storeBanner_id = item.id;
                      prev.media_id = item.media_id;
                      return prev;
                    });
                    setHeaderInfo((prev) => {
                      prev.companyBackground = item.media_link;
                      forceUpdate();
                      return prev;
                    });
                  }
                });
              }
              SetModaldes(false)
            })
            .catch((e) => {
              console.log(e);
            });
        }
      })
      .catch((e) => {
        console.log(e);
      });

    axios
      .put(`/Store/${storeID}`, editHeader)
      .then((res) => {
        if (res.data.status) {
          
          dispatch(ShowAlert(true, res.data.message));
          setEditHeader((prev) => {
            prev.phone_store = null;
            prev.storeIcon_id = null;
            prev.storeShortDes = null;
            prev.storeState = null;
            prev.store_name = null;
            return prev;
          });
          axios
            .get("/Store/showInfo")
            .then((res) => {
              
              if (res.data.status) {
                setEditHeader((prev) => {
                  prev.phone_store = res.data.data.phone_store;
                  prev.storeIcon_id = res.data.data.storeIcon_id;
                  prev.storeShortDes = res.data.data.store_short_des;
                  prev.province_id = res.data.data.province_id;
                  prev.city_id = res.data.data.city_id;
                  prev.store_name = res.data.data.store_name;
                  return prev;
                });

              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (

    <>
      {
        btn ? <div className="edit-store-footer">
          <Modal
            onBackdropClick={() => closeModals()}
            className="edit-store-footer-modal-all"
            open={modaldes}
          >
            <div className="edit-store-footer-modal-all-box">
              <div className="edit-store-footer-modal-header">
                <p>ویرایش توضیحات عنوان</p>
                <img src={cross} onClick={() => closeModal()} />
              </div>
              <div className="edit-store-footer-modal-input-box">
                <div className="edit-store-footer-modal-input-box-2">
                  <p>عنوان  :</p>
                  <InputComponent
                    value={editHeader.storeShortDes}
                    width="calc(90% - 10px)"
                    height="44px"
                    type="text"
                    inputType="input"
                    placeholder="عنوان"
                    borderColor="#dcdcdc"
                    onchange={(e) => {
                      setEditHeader((prev) => {
                        prev.storeShortDes = e.target.value;
                        forceUpdate();
                        return prev;
                      });
                    }}
                  />
                </div>
              </div>
              <div className="edit-store-footer-modal-buttons-box">
                <button
                  onClick={() => closeModals()}
                  className="edit-store-footer-modal-buttons-cancel"
                >
                  لغو
                </button>
                <button
                  onClick={() => editHeaderClik()}
                  className="edit-store-footer-modal-buttons-share"
                >
                  ذخیره
                </button>
              </div>
            </div>
          </Modal>
          <Modal
        onBackdropClick={() => closeModal()}
        className="edit-store-footer-modal-all"
        open={modal}
      >
        <div className="edit-store-footer-modal-all-box">
          <div className="edit-store-footer-modal-header">
            <p>ویرایش شبکه های فوتر سایت</p>
            <img src={cross} onClick={() => closeModal()} />
          </div>
          <div className="edit-store-footer-modal-input-box">
            <div className="edit-store-footer-modal-input-box-2">
              <p>ایمیل :</p>
              <InputComponent
                value={email.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setemail((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>شماره تلفن :</p>
              <InputComponent
                value={phonenumber.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setphonenumber((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>استان :</p>
              <InputComponent
                value={province.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setprovince((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>شهر:</p>
              <InputComponent
                value={city.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setcity((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>آدرس:</p>
              <InputComponent
                value={address.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setaddress((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>نام فروشگاه:</p>
              <InputComponent
                value={store_name.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setstore_name((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>تلگرام :</p>
              <InputComponent
                value={telegram.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setTelegram((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>واتساپ :</p>
              <InputComponent
                value={whatsapp.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setWatsapp((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
            <div className="edit-store-footer-modal-input-box-2">
              <p>اینستاگرام :</p>
              <InputComponent
                value={instagram.value}
                width="calc(82% - 20px)"
                height="44px"
                type="text"
                inputType="input"
                placeholder=""
                borderColor="#dcdcdc"
                onchange={(e) => {
                  setInstagram((prev) => {
                    prev.value = e.target.value;
                    forceUpdate();
                    return prev;
                  });
                }}
              />
            </div>
          </div>
          <div className="edit-store-footer-modal-buttons-box">
            <button
              onClick={() => closeModal()}
              className="edit-store-footer-modal-buttons-cancel"
            >
              لغو
            </button>
            <button
              onClick={() => shareSocial()}
              className="edit-store-footer-modal-buttons-share"
            >
              ذخیره
            </button>
          </div>
        </div>
      </Modal>
          <div className="edit-store-footer-icon-box">
            <div className="pr-6 py-5 w-full">
              <div className="w-full flex items-center gap-5 m-2">
                <p>نام فروشگاه</p>
                <p>{store_name.value}</p>
              </div>
              <div className="w-full flex items-center gap-5 m-2">
                <div className="w-full flex items-center gap-5 m-2">
                  <p>ایمیل</p>
                  <p>{email.value}</p>
                </div>
                <div className="w-full flex items-center gap-5 m-2">
                  <p>شماره تماس</p>
                  <p>{phonenumber.value}</p>
                </div>
              </div>
              <div className="w-full flex items-center gap-5 m-2">
                <div className="w-full flex items-center gap-5 m-2">
                  <p>استان</p>
                  <p>{province.value}</p>
                </div>
                <div className="w-full flex items-center gap-5 m-2">
                  <p>شهر</p>
                  <p>{city.value}</p>
                </div>
              </div>
              <div className="w-full flex items-center gap-5 m-2">
                <p>آدرس</p>
                <p>{address.value}</p>
              </div>
            </div>
            <div className="flex items-center w-full pr-6 gap-5 justify-start -translate-x-32 ">
              <div className="edit-store-footer-icon-box-2">
              
                <img
                  whatsappwhite
                  onClick={() => whatsAppClick()}
                  className={
                    whatsapp.value === null
                      ? "edit-store-footer-icon-img"
                      : "edit-store-footer-icon-img-enable"
                  }
                  src={whatsappimg}
                  onMouseEnter={
                    whatsapp.value != null
                      ? (e) => (e.currentTarget.src = whatsappwhite)
                      : (e) => (e.currentTarget.src = whatsappimg)
                  }
                  onMouseLeave={(e) => (e.currentTarget.src = whatsappimg)}
                />
                <p>{whatsapp.value}</p>
                <img
                  onClick={() => telegramClick()}
                  className={
                    telegram.value === null
                      ? "edit-store-footer-icon-img"
                      : "edit-store-footer-icon-img-enable"
                  }
                  src={telegramimg}
                  onMouseEnter={
                    telegram.value != null
                      ? (e) => (e.currentTarget.src = telegramWhite)
                      : (e) => (e.currentTarget.src = telegramimg)
                  }
                  onMouseLeave={(e) => (e.currentTarget.src = telegramimg)}
                />
                <p>{telegram.value}</p>
                <img
                  onClick={() => instagramClick()}
                  className={
                    instagram.value === null
                      ? "edit-store-footer-icon-img"
                      : "edit-store-footer-icon-img-enable"
                  }
                  src={instagramimg}
                  onMouseEnter={
                    instagram.value != null
                      ? (e) => (e.currentTarget.src = instagramWhite)
                      : (e) => (e.currentTarget.src = instagramimg)
                  }
                  onMouseLeave={(e) => (e.currentTarget.src = instagramimg)}
                />
                <p>{instagram.value}</p>
              </div>
            </div>
            <div className="w-full">
              
            {editHeader?.storeShortDes == null ||
              editHeader?.storeShortDes == "" ? (
              <div className="edit-store-header-image-box-2-brand-title-box-2">
                <p>توضیحات عنوان</p>
              </div>
            ) : (
              <div className="flex flex-col w-full">
                <p className="px-5 w-full textstart">
                  درباره فروشگاه
                </p>
                    <p className="textstart">{description.value}</p>
                <div className="flex items-center w-full">
                      <p className=" px-5 basis-34 max-w-35rem text-start textstart">
                    {editHeader?.storeShortDes}
                      </p>
                </div>
              </div>
            )}
            </div>
            <p className="text-start pr-5 my-4 w-full textstart">کليه حقوق اين سايت متعلق به شرکت ({globalState.store_faName} ) می‌باشد پیاده سازی شده توسط تیم فنی ویستا</p>
          </div>
          {/* btn */}
          <div className="flex flex-col justify-around h-full px-2">
          <button onClick={() => openModal()} className={`${btn ? 'edit-store-slider-edit-buttonnew mt-2' : 'edit-store-top-product-button'}`}>
            <img style={{ marginLeft: "10px" }} src={whiteEdit} />
            ویرایش
            </button>
            <button onClick={() => openModals()} className={`${btn ? 'edit-store-slider-edit-buttonnew mt-2' : 'edit-store-top-product-button'} basis-1/8`}>
              <img style={{ marginLeft: "10px" }} src={whiteEdit} />
              ویرایش
            </button>
          </div>
        </div>
          : <div className="edit-store-footer">
          <Modal
            onBackdropClick={() => closeModal()}
            className="edit-store-footer-modal-all"
            open={modal}
          >
            <div className="edit-store-footer-modal-all-box">
              <div className="edit-store-footer-modal-header">
                <p>ویرایش شبکه های اجتماعی</p>
                <img src={cross} onClick={() => closeModal()} />
              </div>
              <div className="edit-store-footer-modal-input-box">
                <div className="edit-store-footer-modal-input-box-2">
                  <p>تلگرام :</p>
                  <InputComponent
                    value={telegram.value}
                    width="calc(82% - 20px)"
                    height="44px"
                    type="text"
                    inputType="input"
                    placeholder=""
                    borderColor="#dcdcdc"
                    onchange={(e) => {
                      setTelegram((prev) => {
                        prev.value = e.target.value;
                        forceUpdate();
                        return prev;
                      });
                    }}
                  />
                </div>
                <div className="edit-store-footer-modal-input-box-2">
                  <p>واتساپ :</p>
                  <InputComponent
                    value={whatsapp.value}
                    width="calc(82% - 20px)"
                    height="44px"
                    type="text"
                    inputType="input"
                    placeholder=""
                    borderColor="#dcdcdc"
                    onchange={(e) => {
                      setWatsapp((prev) => {
                        prev.value = e.target.value;
                        forceUpdate();
                        return prev;
                      });
                    }}
                  />
                </div>
                <div className="edit-store-footer-modal-input-box-2">
                  <p>اینستاگرام :</p>
                  <InputComponent
                    value={instagram.value}
                    width="calc(82% - 20px)"
                    height="44px"
                    type="text"
                    inputType="input"
                    placeholder=""
                    borderColor="#dcdcdc"
                    onchange={(e) => {
                      setInstagram((prev) => {
                        prev.value = e.target.value;
                        forceUpdate();
                        return prev;
                      });
                    }}
                  />
                </div>
                <div className="edit-store-footer-modal-input-box-2">
                  <p>آپارات :</p>
                  <InputComponent
                    value={aparat.value}
                    width="calc(82% - 20px)"
                    height="44px"
                    type="text"
                    inputType="input"
                    placeholder=""
                    borderColor="#dcdcdc"
                    onchange={(e) => {
                      setAparat((prev) => {
                        prev.value = e.target.value;
                        forceUpdate();
                        return prev;
                      });
                    }}
                  />
                </div>
                <div className="edit-store-footer-modal-input-box-2">
                  <p>لینکدین :</p>
                  <InputComponent
                    value={linkdin.value}
                    width="calc(82% - 20px)"
                    height="44px"
                    type="text"
                    inputType="input"
                    placeholder=""
                    borderColor="#dcdcdc"
                    onchange={(e) => {
                      setLinkdin((prev) => {
                        prev.value = e.target.value;
                        forceUpdate();
                        return prev;
                      });
                    }}
                  />
                </div>
              </div>
              <div className="edit-store-footer-modal-buttons-box">
                <button
                  onClick={() => closeModal()}
                  className="edit-store-footer-modal-buttons-cancel"
                >
                  لغو
                </button>
                <button
                  onClick={() => shareSocial()}
                  className="edit-store-footer-modal-buttons-share"
                >
                  ذخیره
                </button>
              </div>
            </div>
          </Modal>
          <div className="edit-store-footer-icon-box my-5">
              
            <div className="edit-store-footer-icon-box-2">
              <img
                whatsappwhite
                onClick={() => whatsAppClick()}
                className={
                  whatsapp.value === null
                    ? "edit-store-footer-icon-img"
                    : "edit-store-footer-icon-img-enable"
                }
                src={whatsappimg}
                onMouseEnter={
                  whatsapp.value != null
                    ? (e) => (e.currentTarget.src = whatsappwhite)
                    : (e) => (e.currentTarget.src = whatsappimg)
                }
                onMouseLeave={(e) => (e.currentTarget.src = whatsappimg)}
              />
                
              <img
                onClick={() => linkdinClick()}
                className={
                  linkdin.value === null
                    ? "edit-store-footer-icon-img"
                    : "edit-store-footer-icon-img-enable"
                }
                src={linkedinimg}
                onMouseEnter={
                  linkdin.value != null
                    ? (e) => (e.currentTarget.src = linkedinWhite)
                    : (e) => (e.currentTarget.src = linkedinimg)
                }
                onMouseLeave={(e) => (e.currentTarget.src = linkedinimg)}
                />
                <img
                  onClick={() => telegramClick()}
                  className={
                    telegram.value === null
                      ? "edit-store-footer-icon-img"
                      : "edit-store-footer-icon-img-enable"
                  }
                  src={telegramimg}
                  onMouseEnter={
                    telegram.value != null
                      ? (e) => (e.currentTarget.src = telegramWhite)
                      : (e) => (e.currentTarget.src = telegramimg)
                  }
                  onMouseLeave={(e) => (e.currentTarget.src = telegramimg)}
                />
                <img
                  onClick={() => instagramClick()}
                  className={
                    instagram.value === null
                      ? "edit-store-footer-icon-img"
                      : "edit-store-footer-icon-img-enable"
                  }
                  src={instagramimg}
                  onMouseEnter={
                    instagram.value != null
                      ? (e) => (e.currentTarget.src = instagramWhite)
                      : (e) => (e.currentTarget.src = instagramimg)
                  }
                  onMouseLeave={(e) => (e.currentTarget.src = instagramimg)}
                />
                <img
                  onClick={() => aparatClick()}
                  className={
                    aparat.value === null
                      ? "edit-store-footer-icon-img"
                      : "edit-store-footer-icon-img-enable"
                  }
                  src={aparatimg}
                  onMouseEnter={
                    aparat.value != null
                      ? (e) => (e.currentTarget.src = aparatwhite)
                      : (e) => (e.currentTarget.src = aparatimg)
                  }
                  onMouseLeave={(e) => (e.currentTarget.src = aparatimg)}
                />
          </div>

              <p>کليه حقوق اين سايت متعلق به شرکت ({globalState.store_faName} ) می‌باشد پیاده سازی شده توسط تیم فنی ویستا</p>
        </div>
            

            <button onClick={() => openModal()} className="edit-store-footer-button">
              <img style={{ marginLeft: "10px" }} src={whiteEdit} />
              ویرایش
            </button>

        </div>}

    </>
  );
}
